import { render, staticRenderFns } from "./ValidationAlert.vue?vue&type=template&id=539c4405"
import script from "./ValidationAlert.vue?vue&type=script&lang=js"
export * from "./ValidationAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports